<template>
    <div v-if="message">
        <header class="bg-gray-100 text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 flex flex-col md:flex-row-reverse" style="max-width: 1800px">
                <div class="md:w-72 mb-12 md:mb-0 md:ml-8 lg:ml-12">
                </div>
                <div class="flex-1">
                    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-8">
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Message from:</h2>
                            <p class="mt-1 text-gray-500">{{ message.from }}</p>
                        </div>
                        <div class="text-xl">
                            <div class="text-gray-500">
                                <h2 class="font-semibold text-gray-700">Sent at:</h2>
                                <p class="mt-1 text-gray-500">
                                    {{ formatDate(message.statusLogs.find((i) => i.who === message.fromId).sentAt) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="bg-white text-gray-700">
            <div class="w-full mx-auto px-8 pt-8 pb-2 flex flex-col lg:flex-row-reverse"
                 style="max-width: 1800px">
                <div class="lg:w-72 mb-12 lg:mb-0 lg:ml-12 ">
                    <div class="space-y-8 sticky top-4">
                    </div>
                </div>
                <div class="flex-1">
                    <div class="text-gray-700">
                        <label>Message:</label>
                        <p class="whitespace-pre-wrap" v-text="message.message"></p>
                    </div>
                </div>
            </div>
            <template v-for="attachment in message.attachments">
                <div class="w-full mx-auto px-8 pt-2 pb-2"
                     style="max-width: 1800px">
                    <hr>
                    <message-defect v-if="attachment.type==='DEFECT'" :defect="attachment"></message-defect>
                    <message-ppe-register v-else-if="attachment.type==='PPE_REGISTER'"
                                          :ppe-register="attachment"></message-ppe-register>
                    <message-toolbox-talk v-else-if="attachment.type==='TOOLBOX_TALK'"
                                          :toolbox-talk="attachment"></message-toolbox-talk>
                    <message-daily-briefing v-else-if="attachment.type==='DAILY_BRIEFING'"
                                            :daily-briefing="attachment"></message-daily-briefing>
                    <message-non-conformance-report v-else-if="attachment.type==='NON_CONFORMANCE_REPORT'"
                                                    :non-conformance-report="attachment"></message-non-conformance-report>
                    <message-purchase-order v-else-if="attachment.type==='PURCHASE_ORDER'"
                                                    :purchase-order="attachment"></message-purchase-order>
                </div>
            </template>

        </main>
    </div>
</template>

<script>

import {Message} from "@models";
import MessageDefect from "./attachments/MessageDefect.vue";
import MessagePpeRegister from "./attachments/MessagePpeRegister.vue";
import MessageToolboxTalk from "./attachments/MessageToolboxTalk.vue";
import MessageDailyBriefing from "./attachments/MessageDailyBriefing.vue";
import moment from "moment";
import MessageNonConformanceReport from "./attachments/MessageNonConformanceReport.vue";

export default {
    components: {
        MessageNonConformanceReport,
        MessageDailyBriefing, MessageToolboxTalk, MessagePpeRegister, MessageDefect},
    props: {
        id: '',
        channel: '',
        channelId: '',
    },
    data() {
        return {
            message: null,
        }
    },
    computed: {},
    methods: {
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss');
        }
    },

    async mounted() {
        if (this.id) {
            if (this.channelId) {
                this.message = await Message.find(this.channelId, this.id);
            } else {
                this.message = await Message.findExternal(this.channel, this.id);
            }
        }
    },
}
</script>
